// components/auth/AuthCallback.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { LoadingScreen } from "../common/LoadingSpinner";

const AuthCallback = () => {
	const navigate = useNavigate();
	const { login } = useAuth();

	useEffect(() => {
		const handleCallback = async () => {
			const params = new URLSearchParams(window.location.search);
			const tokensStr = params.get("tokens");
			const userStr = params.get("user");

			if (tokensStr && userStr) {
				try {
					const tokens = JSON.parse(decodeURIComponent(tokensStr));
					const user = JSON.parse(decodeURIComponent(userStr));

					const success = await login({ tokens, user });
					if (success) {
						navigate("/dashboard", { replace: true });
					} else {
						throw new Error("Login failed");
					}
				} catch (error) {
					console.error("Auth callback error:", error);
					navigate("/login?error=auth_failed", { replace: true });
				}
			} else {
				console.error("Missing tokens or user data");
				navigate("/login?error=missing_data", { replace: true });
			}
		};

		handleCallback();
	}, [navigate, login]);

	return <LoadingScreen />;
};

export default AuthCallback;
